import { useRef, useState } from "react";
import { EllipsisIcon } from "../icons";
import { Button } from "../elements/Button";
import { useDismissOnOutsideClick } from "../hooks/useDismissOnOutsideClick";
import { PageBarKebabMenuProps } from "./PageBarKebabMenu.types";

/** Shared "more actions" kebab menu for entity page bars. */
export function PageBarKebabMenu({ children }: PageBarKebabMenuProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useDismissOnOutsideClick(containerRef, open, () => setOpen(false));

  return (
    <div className="position-relative" ref={containerRef}>
      <Button
        title="More"
        icon={EllipsisIcon}
        className="border rounded-2 bg-white hover-bg-light d-flex align-items-center justify-content-center p-0 header-bar-icon-btn"
        onClick={() => setOpen((previous) => !previous)}
      />
      {open && (
        <div id="header-bar-kebab-menu" className="header-bar-menu">
          {children(() => setOpen(false))}
        </div>
      )}
    </div>
  );
}

export default PageBarKebabMenu;
